<template>
    <div class="gcmcn-card-gradient">
        <div
            v-if="loading"
            class="loading-container"
        >
            <loader></loader>
        </div>
        <el-form
            v-else
            ref="form"
            :model="form"
        >
            <el-form-item class="gcmcn-form-input" prop="taker">
                <div class="gcmcn-form-label">Taker</div>
                <el-select
                    v-model="form.taker"
                    popper-class="gcmcn-popper"
                    size="mini"
                    clearable
                    :disabled="disableTaker"
                    @change="takerChanged"
                >
                    <el-option
                        v-for="taker in takersToExport"
                        :key="taker.uid"
                        :label="taker.name"
                        :value="taker.uid"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="gcmcn-form-input" prop="event">
                <div class="gcmcn-form-label">Event</div>
                <el-select
                    v-model="form.event"
                    popper-class="gcmcn-popper"
                    size="mini"
                    clearable
                    :disabled="disableEvent"
                    @change="eventChanged"
                >
                    <el-option
                        v-for="event in eventsToExport"
                        :key="event.uid"
                        :label="event.name"
                        :value="event.uid"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="gcmcn-form-input" prop="feed_resource">
                <div class="gcmcn-form-label">Feed Resource</div>
                <el-select
                    v-model="form.feed_resource"
                    popper-class="gcmcn-popper"
                    size="mini"
                    clearable
                    :disabled="disableResource"
                    @change="feedResourceChanged"
                >
                    <el-option
                        v-for="resource in feedResourceToExport"
                        :key="resource.uid"
                        :label="resource.name"
                        :value="resource.uid"
                    ></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div
            v-if="!loading"
            class="export-btn"
        >
            <el-button
                type="primary"
                size="mini"
                @click="exportConfigurations"
            >
                Export
            </el-button>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/loader-template.vue';
import moment from 'moment';
export default {

    name: 'export-view',

    components:{
        Loader
    },

    props:{
        takersToExport:{
            type: Array,
            required: true
        },
        feedResourceToExport:{
            type: Array,
            required: true
        },
        eventsToExport:{
            type: Array,
            required: true
        },
        entity: {
            type: Object,
            required: true,
        },
    },

    data () {
        return {
            form:{
                taker: '',
                event: '',
                feed_resource: '',
            },
            disableTaker: false,
            disableEvent: false,
            disableResource: false,
            loading: false
        };
    },

    methods:{
        selectDisabled(){
            if(this.form.taker){
                this.$set(this, 'disableEvent', true);
                this.$set(this, 'disableResource', true);
            } else if(this.form.event){
                this.$set(this, 'disableTaker', true);
                this.$set(this, 'disableResource', true);
            } else if(this.form.feed_resource){
                this.$set(this, 'disableTaker', true);
                this.$set(this, 'disableEvent', true);
            } else {
                this.$set(this, 'disableTaker', false);
                this.$set(this, 'disableEvent', false);
                this.$set(this, 'disableResource', false);
            }
        },
        takerChanged(value){
            this.$set(this.form, 'taker', value);
            this.selectDisabled();
        },
        eventChanged(value){
            this.$set(this.form, 'event', value);
            this.selectDisabled();
        },
        feedResourceChanged(value){
            this.$set(this.form, 'feed_resource', value);
            this.selectDisabled();
        },
        exportConfigurations(){
            let item = {export_filters: {}};
            let availableFilters = ['taker', 'event', 'feed_resource'];
            availableFilters.map((filterName) => {
                if(this.form[filterName] !== ''){
                    return item.export_filters[filterName] = this.form[filterName];
                }
            });
            this.loading = true;
            this.$store.dispatch('createItem', {
                item: item,
                model: 'exportConfigurationRequests',
                url: this.$store.state.api.meta.listModels.exportConfigurationRequests.url,
                scopes: {'X-Entity-Uid': this.entity.uid},
            })
            .then(async(res) => {
                this.$store.dispatch('fundation/watchRequestStatus',{
                    url: res.url
                }).then((response) => {
                    this.$notify.success({
                        title: 'Success',
                        message: 'Your export is ready'
                    });
                    let link = document.createElement('a');
                    link.style = 'display: none';
                    link.href = response.data.file;
                    document.body.appendChild(link);
                    link.click(); // This will download the data file.
                    this.loading = false;
                }).catch((error) => {
                    this.loading = false;
                    this.$notify.error({
                        title: 'Error',
                        message: `${error.data.verbose_status}`
                    });
                });
            }).catch((e) => {
                this.loading = false;
                console.error(e);
            });
        }
    }
};
</script>

<style lang="scss">
.loading-container{
    display: flex;
    justify-content: center;
    margin-top: 2rem;
}
.export-btn{
    float: right;
    margin-top: 2rem;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Entities/export-view.vue